import { useCallback, useMemo, useRef, useState } from "react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";

// Excel yükleme durumu: dosya, meşgul, sonuç + yükle; onDone(data) toast/yenileme yapar, clearOnSuccess dosyayı sıfırlar (lastFile hatalı satır indirme için kalır)
export function useExcelUpload({ url, onDone, clearOnSuccess = false }) {
  const [file, setFileRaw] = useState(null);
  const [lastFile, setLastFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const ref = useRef({ url, onDone });
  ref.current = { url, onDone };
  const setFile = useCallback((f) => { setFileRaw(f); setResult(null); }, []);
  const upload = useCallback(async () => {
    if (!file) return;
    setBusy(true);
    setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const target = typeof ref.current.url === "function" ? ref.current.url() : ref.current.url;
      const { data } = await http.post(target, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setLastFile(file);
      setResult(data);
      if (clearOnSuccess) setFileRaw(null);
      await ref.current.onDone?.(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  }, [file, clearOnSuccess]);
  return useMemo(() => ({ file, lastFile, busy, result, setFile, upload }), [file, lastFile, busy, result, setFile, upload]);
}
